// @flow
import React, { useEffect, useRef } from 'react';
import { attachSheetDrag } from '@helpers/sheetDrag';
import { SHEETS } from '@helpers/sheetMotion';

type Props = {
  onClose: Function, // what the backdrop does: close without choosing anything
};

// The grab strip at the top of a phone bottom sheet (the bar itself is the sheet's ::before, styles.resources.scss).
// Put it inside the sheet: it makes the whole sheet draggable down to close (helpers/sheetDrag). The panel and the
// backdrop are the ones the exit slides (sheetMotion's SHEETS), so a sheet let go mid-drag leaves from there.
const SheetGrabber = ({ onClose }: Props) => {
  const ref = useRef(null);
  const close = useRef(onClose);
  close.current = onClose;

  useEffect(() => {
    const root = ref.current && ref.current.closest('.modal, .dayPickerOverlay');
    if (!root) return undefined;
    const plan = root.classList.contains('dayPickerOverlay') ? SHEETS.dayPicker : SHEETS.list;
    const sheet = root.querySelector(plan.panel);
    if (!sheet) return undefined;
    return attachSheetDrag(sheet, { backdrop: root.querySelector(plan.backdrop), onClose: () => close.current() });
  }, []);

  return <div className="sheetGrabber" ref={ref} aria-hidden="true" />;
};

export default SheetGrabber;
